import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'rmt-circle',
  templateUrl: 'rmt-circle.html'
})
export class RmtCircleComponent {
  @ViewChild('maskedImgControl', { read: ElementRef }) maskedImgControl;
  @Input() img;
  @Input() maskedImg;
  @Input() spinning: boolean = false;
  
  constructor() {    
  }

  ngAfterViewInit()
  {
    if (this.maskedImgControl)
      this.maskedImgControl.nativeElement.style.webkitMaskImage = 'url(../' + this.maskedImg + ')';
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-circle/rmt-circle.ts